var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationImportant2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#7500C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.01 20.76C10.01 21.86 10.9 22.75 12 22.75C13.1 22.75 13.99 21.86 13.99 20.76H10.01ZM12 5.75C14.76 5.75 17 7.99 17 10.75V17.75H7V10.75C7 7.99 9.24 5.75 12 5.75ZM12 1.25C11.17 1.25 10.5 1.92 10.5 2.75V3.92C7.36 4.6 5 7.4 5 10.75V16.75L3 18.75V19.75H21V18.75L19 16.75V10.75C19 7.4 16.64 4.6 13.5 3.92V2.75C13.5 1.92 12.83 1.25 12 1.25ZM11 7.75H13V11.75H11V7.75ZM11 13.75H13V15.75H11V13.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationImportant2);
export default __webpack_public_path__ + "static/media/notification_important (2).d0814bec1821cfa1d523daa472eab06d.svg";
export { ForwardRef as ReactComponent };